import api from '../../services/api';
import { Creators } from '../ducks/year';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getYears({ filter }) {
  try {
    let response;

    yield put(Creators.yearRequest());
    response = yield call(api.post, 'year', filter);

    yield put(Creators.yearSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.yearError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar intervalo dos anos'
    }));
  }
}